import React from 'react'
import IconButton from './IconButton'

export default function QuantityControl({
  quantity,
  onIncrease,
  onDecrease,
  itemName,
  showZeroState = false,
  minusVariant = 'gray',
}) {
  const minusClasses = minusVariant === 'gray'
    ? 'w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center font-bold transition flex-shrink-0 focus:outline-none focus:ring-2 focus:ring-sky-500'
    : ''

  if (showZeroState && quantity === 0) {
    return (
      <div className="flex items-center gap-2 flex-shrink-0" role="group" aria-label={`Quantity for ${itemName}`}>
        <IconButton onClick={onIncrease} ariaLabel={`Add ${itemName} to basket`}>
          +
        </IconButton>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 flex-shrink-0" role="group" aria-label={`Quantity for ${itemName}`}>
      {minusVariant === 'primary' ? (
        <IconButton onClick={onDecrease} ariaLabel={`Remove one ${itemName}`} className="text-lg">
          −
        </IconButton>
      ) : (
        <button
          type="button"
          onClick={onDecrease}
          className={minusClasses}
          aria-label={`Remove one ${itemName}`}
        >
          −
        </button>
      )}
      <span className="w-8 text-center font-medium" aria-live="polite" aria-atomic="true">
        {quantity}
      </span>
      <IconButton onClick={onIncrease} ariaLabel={`Add one more ${itemName}`}>
        +
      </IconButton>
    </div>
  )
}
